(function () {
    var trigger = "";
    //on document loaded
    document.addEventListener('DOMContentLoaded', function () {
        console.debug("INFO mapzipsearch.js loaded");

        //get all maps on page
        var mapnavigation = document.querySelectorAll(".js-map-zipsearch");
        //run over all maps
        for (var i = 0; i < mapnavigation.length; i++) {
            //get all button/inputs in map component
            var searchfield = mapnavigation[i].querySelector(".js-map-zipsearch-search-field");
            var searchbutton = mapnavigation[i].querySelector(".js-map-zipsearch-search-button");
            // close button
            var searchbuttonreset = mapnavigation[i].querySelector(".js-map-zipsearch-search-button-reset");
            //suche aufheben button
            var resetButton = mapnavigation[i].querySelector(".js-map-zipsearch-reset-button");

            // implementation of Scrolling Functionality
            var map = mapnavigation[i].querySelector(".js-map-zipsearch-svg");
            if (map !== null) {
                map.querySelectorAll('[data-ref]').forEach(function (item) {
                    item.addEventListener("click", function (event) {
                        var element = event.target;
                        var attrRef = element.getAttribute('data-ref');
                        var mapComponent = element.parentNode.closest('.js-map-zipsearch');
                        var targetElement = mapComponent.querySelector("[data-target=" + attrRef + "]");
                        if (targetElement !== null) {
                            var smoothScroll = new window.SmoothScroll();
                            smoothScroll.animateScroll(targetElement.parentNode);
                        }
                    });
                });
            }

            //add listener for clicking these buttons/inputs
            //filter on enter
            searchfield.addEventListener("keydown", function (e) {
                if (!e) {
                    e = window.event;
                }
                //if enter key
                if (e.keyCode === 13) {
                    trigger = "enter";
                    resetSearch(e);
                    filterZipCode(e);
                }
            }, false);

            //filter on click on magnyfiying glass button
            searchbutton.addEventListener("click", function (e) {
                trigger = "button";

                resetSearch(e);
                filterZipCode(e);
            });

            //reset search by click the cross in search input field
            searchbuttonreset.addEventListener("click", function (e) {
                var mapComponent = e.target.parentNode.closest('.js-map-zipsearch');
                mapComponent.querySelector('.js-map-zipsearch-search-field').value = '';
                resetSearch(e);
            });
            //reset filter by clicking reset search button
            resetButton.addEventListener("click", function (e) {
                // if Map is highlighted, then Highlight should be removed if Search is resetted.
                // Searh Field should be empty when Search is resetted too.
                var mapComponent = e.target.parentNode.closest('.js-map-zipsearch');
                var highlighted = mapComponent.querySelector('.js-map-highlight.is-active');

                if (highlighted) {
                    highlighted.classList.remove('is-active');
                }
                mapComponent.querySelector('.js-map-zipsearch-search-field').value = '';
                resetSearch(e);
            });
        }
    }, false);

    function resetSearch(event) {
        //go to parent and search input field and take value
        var parent;
        if (trigger === "enter") {
            parent = event.target.parentNode;
        } else if (trigger === "button") {
            parent = event.target.parentNode.parentNode;
        }

        if (parent !== null) {
            //get all elements which has to be reset
            var mapComponent = parent.closest('.js-map-zipsearch');

            var hideTeamsBeforeSearchDiv = mapComponent.querySelector(".dmp-map-zipsearch--hide-teams-selector");
            var mapZipSearchInput = mapComponent.querySelector(".js-map-zipsearch-input");
            var searchbutton = mapComponent.querySelector(".js-map-zipsearch-search-button");
            var searchbuttonreset = mapComponent.querySelector(".js-map-zipsearch-search-button-reset");
            var resetbutton = mapComponent.querySelector(".js-map-zipsearch-reset-button");
            var invalidZipField = mapComponent.querySelector(".js-map-zipsearch-show-on-invalid-zip-code");

            //Move Search Button on the place of Reset Search Button
            mapZipSearchInput.insertBefore(searchbutton, searchbuttonreset);

            //reset fields
            searchbutton.classList.remove("c-map-navigation__hide_field");
            searchbuttonreset.classList.add("c-map-navigation__hide_field");
            resetbutton.classList.add("c-map-navigation__hide_field");
            if (invalidZipField !== null) {
                invalidZipField.classList.add("c-map-navigation__hide_field");
            }

            //reset all hidden fields to visible
            var hiddenFields = mapComponent.querySelectorAll(".js-map-zipsearch-show-on-resest");
            for (var i = 0; i < hiddenFields.length; i++) {
                var hiddenField = hiddenFields[i];
                hiddenField.classList.remove("c-map-navigation__hide_field");
            }

            if (hideTeamsBeforeSearchDiv !== null) {
                hideTeamsBeforeSearchDiv.classList.add("dmp-map-zipsearch--hide-teams");
            }
        }
    }

    function filterZipCode(event) {
        //go to parent and search input field and take value
        var parent;
        if (trigger === "enter") {
            parent = event.target.parentNode;
        } else if (trigger === "button") {
            parent = event.target.parentNode.parentNode;
        }

        if (parent !== null) {
            var mapComponent = parent.closest('.js-map-zipsearch');

            //get components of the map navigation components
            var hideTeamsBeforeSearchDiv = mapComponent.querySelector(".dmp-map-zipsearch--hide-teams-selector");
            var mapZipSearchInput = mapComponent.querySelector(".js-map-zipsearch-input");
            var resetSearchButton = mapComponent.querySelector(".js-map-zipsearch-reset-button");
            var searchbutton = mapComponent.querySelector(".js-map-zipsearch-search-button");
            var searchbuttonreset = mapComponent.querySelector(".js-map-zipsearch-search-button-reset");
            var invalidZipField = mapComponent.querySelector(".js-map-zipsearch-show-on-invalid-zip-code");

            var zipCodeString = parent.querySelector(".js-map-zipsearch-search-field").value;

            //extend  onput value with 0
            zipCodeString = extend(zipCodeString);

            //do it only for valid plz
            if (isPLZ(zipCodeString)) {
                // Move Reset Search Button on the place of Search Button
                mapZipSearchInput.insertBefore(searchbuttonreset, searchbutton);

                //hide or show buttons/hint messages^
                resetSearchButton.classList.remove("c-map-navigation__hide_field");
                searchbutton.classList.add("c-map-navigation__hide_field");
                searchbuttonreset.classList.remove("c-map-navigation__hide_field");

                //hide map
                var svg = mapComponent.querySelector(".js-map-zipsearch-svg");
                if (svg !== null) {
                    svg.classList.add("c-map-navigation__hide_field");
                }
                //hide invalid zip code hint if it was shown
                invalidZipField.classList.add("c-map-navigation__hide_field");
                //hide team headers
                var teamHeaders = mapComponent.querySelectorAll(".js-map-zipsearch-componentheader");
                for (var i = 0; i < teamHeaders.length; i++) {
                    teamHeaders[i].classList.add("c-map-navigation__hide_field");
                }
                //get all teams and loop
                var teamLists = mapComponent.querySelectorAll(".js-map-zipsearch-teamlist");
                //hide fields
                var zipCode = parseInt(zipCodeString);
                //loop over teams
                for (var j = 0; j < teamLists.length; j++) {
                    var team = teamLists[j];
                    var teamMembers = teamLists[j].querySelectorAll(".js-map-zipsearch-teammember")
                    var hideTeam = true;
                    //loop over members
                    for (var k = 0; k < teamMembers.length; k++) {
                        var member = teamMembers[k].children[0];
                        var hideMember = true;
                        var dataRangeAttr = member.getAttribute("data-appartenance-zip-area");
                        if (dataRangeAttr !== null) {
                            var zipCodeRanges = dataRangeAttr.split(',');
                            //loop over data ranges set in member
                            for (var l = 0; l < zipCodeRanges.length; l++) {
                                var range = zipCodeRanges[l].split('-');
                                var from = parseInt(range[0]);
                                var to = parseInt(range[1]);
                                if (from <= zipCode && zipCode <= to) {
                                    hideTeam = false;
                                    hideMember = false;
                                }
                            }
                        }
                        if (hideMember) {
                            member.parentNode.classList.add("c-map-navigation__hide_field");
                        }
                    }
                    if (hideTeam) {
                        team.classList.add("c-map-navigation__hide_field");
                    }
                }
                if (hideTeamsBeforeSearchDiv !== null) {
                    hideTeamsBeforeSearchDiv.classList.remove("dmp-map-zipsearch--hide-teams");
                }
            } else { //show hint that zip code is not correct
                // Move Reset Search Button on the place of Search Button
                mapZipSearchInput.insertBefore(searchbuttonreset, searchbutton);
                invalidZipField.classList.remove("c-map-navigation__hide_field");
                searchbutton.classList.add("c-map-navigation__hide_field");
                searchbuttonreset.classList.remove("c-map-navigation__hide_field");
                if (hideTeamsBeforeSearchDiv !== null) {
                    hideTeamsBeforeSearchDiv.classList.add("dmp-map-zipsearch--hide-teams");
                }
            }
        }
    }

    //function to test if input is a german zip code
    function isPLZ(tString) {
        return tString.match(/^[0-9]{5}$/);
    }

    //function to add 0 for zip code lower than 5 digits
    function extend(zipCodeString) {
        var digitslength = zipCodeString.length;
        for (var i = digitslength; i < 5; i++) {
            zipCodeString = zipCodeString + '0';
        }
        return zipCodeString;
    }
})();
